//import * as symbol from 'es6-symbol';

export const STATEX_ACTION_KEY = Symbol('statex:actions');
export const STATEX_DATA_BINDINGS_KEY = Symbol('statex:dataBindings');
